export default __webpack_public_path__ + "static/media/eat_drink.f26a1ca8.jpeg";